import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { SourceType } from '../types';
import type { SectionContext } from './types';

type CapGroupFormState = {
  form?: { offerActionDetail?: { values?: { capGroup?: { id?: number | string; name?: string } | null } } };
};

export function useSectionContext(sourceType: SourceType, hideCapsTab = false): SectionContext {
  const isOfferAction = sourceType === 'offerAction' || sourceType === 'offerActionLinkout';
  const capGroupConfigured = useSelector((s: CapGroupFormState) => {
    if (!isOfferAction) return false;
    const capGroup = s?.form?.offerActionDetail?.values?.capGroup;
    return Boolean(capGroup?.name || capGroup?.id);
  });

  return useMemo(
    () => ({
      sourceType,
      isPublisher: sourceType === 'publisherPrePingCriteria',
      isOfferAction,
      capGroupConfigured,
      hideCapsTab,
    }),
    [sourceType, isOfferAction, capGroupConfigured, hideCapsTab]
  );
}
